<template>
  <div class="mx-1" v-if="acesso.Contrato">
    <b-row>
      <ContratosTotalizadores :isBusy="isBusy" />
    </b-row>
    <b-row>
      <b-card class="w-100">
        <ContratosFiltros :userData="userData" ref="contratoFiltros" :isBusy="isBusy" @carregarGridHandler="carregarGridHandler" />
        <ContratosTabela :userData="userData" ref="contratoTabela" :isBusy="isBusy" :acesso="acesso" />
      </b-card>
    </b-row>
  </div>
  <b-card class="text-center" v-else>
    <b-card-body>
      <b-icon icon="exclamation-triangle" variant="danger" font-scale="2"></b-icon>
      <b-card-title class="text-danger mt-2">Acesso Negado!</b-card-title>
      <b-card-text class="mb-1"> Parece que seu usuário não tem permissão para realizar pesquisas. </b-card-text>
      <b-card-text class="mb-1">
        Para obter acesso, por favor, solicite assistência ou permissões adicionais ao administrador do sistema.
      </b-card-text>
    </b-card-body>
  </b-card>
</template>
<script>
  import ContratosTotalizadores from '@/views/pages/financeiro/contratos/components/contratosLista/contratosTotalizadores.vue'
  import ContratosFiltros from '@/views/pages/financeiro/contratos/components/contratosLista/contratosFiltros.vue'
  import ContratosTabela from '@/views/pages/financeiro/contratos/components/contratosLista/contratosTabela.vue'
  import ContratosContrato from '@/views/pages/financeiro/contratos/contratosContrato.vue'
  export default {
    components: {
      ContratosTotalizadores,
      ContratosFiltros,
      ContratosTabela,
      ContratosContrato,
    },
    data() {
      return {
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        isBusy: true,
        contratoId: null,
        acesso: {
          Contrato: true,
        },
      }
    },
    async mounted() {
      this.isBusy = false
      await this.carregarGridHandler({
        pesquisa: '',
        tipoPesquisa: '',
      })

      if (this.userData.role == 'master') {
        this.acesso.Contrato = true
      } else {
        this.acesso.Contrato = this.userData.GrupoAcesso.Contrato
      }
    },
    methods: {
      carregarGridHandler(filtros) {
        this.$refs.contratoTabela.carregarGrid(filtros)
      },
    },
  }
</script>
